import { config } from '../../../../config/config';
import type { SongPageSection } from './page/catalogSongPath';

/**
 * The native song page of a catalog row: `<scheme>://songFiles?catalogItemUuid=<uuid>[&section=<section>]`.
 * The scheme is `config.nativeAppScheme`, the same one as the other native links
 * (`openAppUrl`). Inside the iOS and Android web view the app opens its own song page.
 * `section` scrolls the page to that section. An old app ignores it and opens the page at its top.
 */
export function songFilesDeepLink(
  catalogItemUuid: string,
  { scheme = config.nativeAppScheme, section }: { scheme?: string; section?: SongPageSection } = {}
): string {
  const sectionPart = section === undefined ? '' : `&section=${section}`;
  return `${scheme}://songFiles?catalogItemUuid=${encodeURIComponent(catalogItemUuid)}${sectionPart}`;
}
